import { Tooltip, styled } from "@mui/material";
import React from "react";

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    "& .MuiTooltip-tooltip": {
        backgroundColor: "white",
        color: "#333",
        fontSize: 12,
        padding: "8px 12px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        border: "1px solid #e0e0e0",
        whiteSpace: "nowrap",
    },
    "& .MuiTooltip-arrow": {
        color: "white",
        "&::before": {
            border: "1px solid #e0e0e0",
        },
    },
});

export const ProgressBar = ({ revenue, budget, isYtd }) => {
    const colorClass = isYtd ? "bg-emerald-200" : "bg-gray-300";
    let fullColor = "bg-gray-200";
    let fullText = "";

    let percentage = 0;
    if (isNaN(revenue) && isNaN(budget)) {
        percentage = 0;
    } else if (budget === 0) {
        if (revenue > 0) {
            percentage = 100;
            fullColor = isYtd ? "bg-emerald-200" : "bg-gray-300";
            fullText = "Revenue";
        }
    } else if (revenue === 0) {
        if (budget > 0) {
            percentage = 100;
            fullColor = "bg-yellow-200";
            fullText = "Budget";
        }
    } else if (revenue > budget) {
        percentage = ((budget / revenue) * 100).toFixed(1);
    } else if (budget > revenue) {
        percentage = ((revenue / budget) * 100).toFixed(1);
    } else {
        percentage = 0;
    }

    const getTooltipText = () => {
        if (percentage === 0) return "0%";
        if (percentage === 100) return `${fullText}: ${percentage}%`;

        if (revenue > budget) {
            if (100 - percentage > percentage) {
                return `Revenue: ${100 - percentage}%, Budget: ${percentage}%`;
            } else {
                return `Revenue: ${percentage}%, Budget: ${100 - percentage}%`;
            }
        } else if (budget > revenue) {
            if (100 - percentage > percentage) {
                return `Budget: ${100 - percentage}%, Revenue: ${percentage}%`;
            } else {
                return `Budget: ${percentage}%, Revenue: ${100 - percentage}%`;
            }
        }
        return `Revenue: ${percentage}%, Budget: ${100 - percentage}%`;
    };

    return (
        <CustomTooltip
            title={getTooltipText()}
            arrow
            placement="top"
            enterDelay={200}
            leaveDelay={200}
        >
            <div className="flex h-6 rounded-full overflow-hidden bg-gray-200">
                {percentage !== 0 && (
                    <>
                        {percentage === 100 ? (
                            <div
                                className={`h-full ${fullColor} flex items-center px-2`}
                                style={{ width: `${percentage}%` }}
                            />
                        ) : (
                            <>
                                {revenue > budget ? (
                                    <>
                                        {100 - percentage > percentage ? (
                                            <>
                                                <div
                                                    className={`h-full ${colorClass} flex items-center px-2`}
                                                    style={{
                                                        width: `${
                                                            100 - percentage
                                                        }%`,
                                                    }}
                                                />
                                                <div
                                                    className="h-full bg-yellow-200 flex items-center px-2"
                                                    style={{
                                                        width: `${percentage}%`,
                                                    }}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <div
                                                    className="h-full bg-yellow-200 flex items-center px-2"
                                                    style={{
                                                        width: `${
                                                            100 - percentage
                                                        }%`,
                                                    }}
                                                />
                                                <div
                                                    className={`h-full ${colorClass} flex items-center px-2`}
                                                    style={{
                                                        width: `${percentage}%`,
                                                    }}
                                                />
                                            </>
                                        )}
                                    </>
                                ) : budget > revenue ? (
                                    <>
                                        {100 - percentage > percentage ? (
                                            <>
                                                <div
                                                    className="h-full bg-yellow-200 flex items-center px-2"
                                                    style={{
                                                        width: `${
                                                            100 - percentage
                                                        }%`,
                                                    }}
                                                />
                                                <div
                                                    className={`h-full ${colorClass} flex items-center px-2`}
                                                    style={{
                                                        width: `${percentage}%`,
                                                    }}
                                                />
                                            </>
                                        ) : (
                                            <>
                                                <div
                                                    className={`h-full ${colorClass} flex items-center px-2`}
                                                    style={{
                                                        width: `${
                                                            100 - percentage
                                                        }%`,
                                                    }}
                                                />
                                                <div
                                                    className="h-full bg-yellow-200 flex items-center px-2"
                                                    style={{
                                                        width: `${percentage}%`,
                                                    }}
                                                />
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <div
                                            className={`h-full ${colorClass} flex items-center px-2`}
                                            style={{ width: `${percentage}%` }}
                                        />
                                        <div
                                            className="h-full bg-yellow-200 flex items-center px-2"
                                            style={{
                                                width: `${100 - percentage}%`,
                                            }}
                                        />
                                    </>
                                )}
                            </>
                        )}
                    </>
                )}
                {percentage === 0 && (
                    <div
                        className="h-full bg-gray-200 flex items-center justify-center px-2"
                        style={{ width: "100%" }}
                    />
                )}
            </div>
        </CustomTooltip>
    );
};
